import type { IconData } from '@stacksjs/iconify-core'

export const tk1x1: IconData = {
  "body": "<path fill=\"#00247d\" d=\"M0 0h512v512H0z\"/><path fill=\"#fed100\" d=\"M90.7 384.2c-5.3 0 50-29.5 96.4-67.2c60.7-49.5 191.5-128.7 230-141.5c4-1.3-8.2 6.8-9.8 9.5c-41.1 48.6-8.3 140.3 43 186.4c15.4 11.8 14.6 12.4 43.2 13.6v2.7zm-3.3 5.4s-3.9 2.8-3.9 4.9c0 2.3 4.4 5.4 4.4 5.4l397.3 4.4l7.3-4.9l-10.2-6.3z\"/><path fill=\"#fff\" d=\"m105.5 116.6l-4 12.1l10.4-7.5l10.3 7.5l-4-12.1l10.4-7.5h-12.8l-3.9-12.2l-4 12.2H95.2zm77.8 57.1l8.6-6.2h-10.6l-3.3-10.1l-3.3 10.1h-10.6l8.6 6.2l-3.3 10.1l8.6-6.2l8.6 6.2zm-144.7 13l-3.9-12.1l-4 12.1H18l10.3 7.5l-4 12.1l10.4-7.5l10.3 7.5l-3.9-12.1l10.3-7.5zm77.9 121.9l-4.6-14.2l-4.6 14.2H92.4l12 8.7l-4.6 14.2l12.1-8.8l12 8.8l-4.6-14.2l12-8.7z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default tk1x1
